import { EntityCardProps } from '../../lib/types';
import { useEntityRoute } from '../../lib/hooks';
import { BaseEntityCard } from '../base-entity-card';

export const EntityCard = (props: EntityCardProps) => {
  const { entity } = props;
  const { entityRoute } = useEntityRoute(entity);
  return (
    <BaseEntityCard
      {...props}
      getActionRoute={() => entityRoute}
      defaultActionLabel="View"
    />
  );
};
